import { AzIcon, EngIcon, KzhIcon, RusIcon, UzbIcon, ZhIcon } from '../_assets/icon-components'
import { TLanguageValue } from '../_types/language'
interface ILanguage {
  id: string
  label: string
  icon: React.ReactNode
  value: TLanguageValue
}

export const languageOptions: ILanguage[] = [
  { id: '1', label: 'O’zbekcha', icon: <UzbIcon />, value: 'uz' },
  { id: '2', label: 'Русский', icon: <RusIcon />, value: 'ru' },
  { id: '3', label: 'English', icon: <EngIcon />, value: 'en' },
  { id: '4', label: 'Қазақ', icon: <KzhIcon />, value: 'kk' },
  { id: '5', label: '中文', icon: <ZhIcon />, value: 'zh' },
  { id: '6', label: 'Azərbaycanca', icon: <AzIcon />, value: 'az' },
]

